import { render } from "./IconUnknow.vue?vue&type=template&id=56852cf3"
const script = {}

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__